import React, { useState } from "react";
import { Divs } from "../../../StyledComponents";
import {
  DebounceSelect,
  Label,
  SelectInput,
  SelectableMenu,
  TextInput,
} from "../../../../globals";
import { errorHandler, returnEuroString } from "../../../../../helpers/Utils";
import {
  IconTimes
} from "../../../../Layout/Icons";
import { FaTrash } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import AntdConfirm from "../../../../../helpers/AntdConfirm";
import { useDispatch } from "react-redux";
import {
  createOrderCartRules,
  deleteOrderCartRules,
  updateOrderCartRules,
} from "../../../../../redux/Actions/orderAction";
import { useForm } from "../../../../../hooks";
import { capitalizeFirstLetter } from "../../../../../utils/string";
import { FaCheck } from "react-icons/fa";

function OrderDiscounts({
  order_rows,
  order_cart_rules,
  order_id,
  availableCreate,
}) {
  return (
    <Divs>
      <div className="table-responsive bg-silver">
        <div
          className="col-12"
        >
          <table
            className="table table-sm mb-0"
            style={{ marginBottom: "0px!important" }}
          >
            <tbody>
              {order_cart_rules.map((order_cart_rule) => (
                <OrderCartRule
                  key={order_cart_rule.id}
                  order_cart_rule={order_cart_rule}
                  order_rows={order_rows}
                />
              ))}
            </tbody>
          </table>
        </div>
        {availableCreate && (
          <>
            <hr className="my-0" />
            <div className="col-12 py-2">
              <OrderDiscountCreate
                initialValues={{ order_id }}
                order_rows={order_rows}
              />
            </div>
          </>
        )}
      </div>
    </Divs>
  );
}

export default OrderDiscounts;

const OrderCartRule = ({ order_cart_rule, order_rows }) => {
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);

  const badgeNames = {
    "manual_product": 'Product',
    "manual_cart": 'Cart',
    "manual_category": 'Category'
  };

  const handleDelete = () => {
    AntdConfirm({
      onOk: () => dispatch(deleteOrderCartRules(order_cart_rule.id, order_cart_rule.order_id))
    });
  }

  if (editMode)
    return (
      <OrderDiscountEdit
        order_cart_rule={order_cart_rule}
        onClose={() => setEditMode(false)}
      />
    );

  let badgeText = badgeNames[order_cart_rule.identifier];

  if (!badgeText) {
    const isProductType = order_rows.some(row => row.id_product === order_cart_rule.id_product);
    badgeText = isProductType ? 'Product' : 'Cart';
  }
  return (
    <tr>
      <td>
        <div className="text-sm py-2 d-flex align-items-center" style={{ gap: 8 }}>
          <p className="order-discount-discount-text">
            {order_cart_rule.title} - {returnEuroString(order_cart_rule.total)}
          </p>
          <div className="badge badge-pill badge-light text-xs text-black px-2 font-normal">
            <p className="order-discount-badge-text">
              {badgeText}
            </p>
          </div>
          <MdEdit style={{ color: "green", cursor: "pointer" }} onClick={() => setEditMode(true)} />
          <FaTrash style={{ color: "orange", cursor: "pointer" }} onClick={handleDelete} />
        </div>
      </td>
    </tr>
  );
};

const OrderDiscountEdit = ({ order_cart_rule, onClose }) => {
  return (
    <tr>
      <td>
        <OrderDiscountCreate initialValues={order_cart_rule} onClose={onClose} />
      </td>
    </tr>
  );
};

const OrderDiscountCreate = ({
  initialValues = {},
  order_rows = [],
  onClose,
}) => {
  const dispatch = useDispatch();
  const { onChange, setForm, form } = useForm({
    id: initialValues?.id || null,
    order_id: initialValues.order_id,
    title: initialValues?.title || "",
    amount: initialValues?.total || 0,
    discount_type: "cart",
    amount_type: "€",
  });

  console.log(form, 'form');

  function renderFormInput() {
    const isProduct = form.discount_type === "product";
    const isCategory= form.discount_type === "category";
    const handleOnChange = (val) => {    
      const orderRows = isProduct
        ? order_rows?.find(order_row => order_row.product_info.id === val)
        : order_rows?.find(order_row => order_row?.shop_category?.id === val)
      console.log(orderRows, 'orderRows')
      const title = isProduct
        ? orderRows?.product_name
        : orderRows?.shop_category.title;

      setForm(prevForm => ({
        ...prevForm,
        [`${form.discount_type}_id`]: val,
        title,
        product_id: isProduct ? orderRows?.id : undefined,
        id_product: isCategory ? orderRows?.id : undefined,
      }));


      onChange({
        target: {
          name: [`${form.discount_type}_id`],
          title,
          value: val,
        },
      });
    };

    if (!form.id && isProduct) {
      const options = order_rows
        .filter(({ product_info, order_cart_rule_id }) => !!product_info && !order_cart_rule_id)
        .map((order_row) => ({
          value: order_row.product_info.id,
          label: order_row.product_name,
        }));

      return (
        <SelectInput
          label={capitalizeFirstLetter(form.discount_type)}
          value={form[`title`] || undefined}
          options={options}
          onChange={handleOnChange}
        />
      );
    } else if (isCategory) {
      const options = order_rows
        .filter(({ shop_category }) => !!shop_category?.id && !!shop_category?.title)
        .map((order_row) => ({
          value: order_row?.shop_category?.id,
          label: order_row?.shop_category?.title,
        }));
      return (
        <SelectInput
          label={capitalizeFirstLetter(form.discount_type)}
          value={form[`title`] || undefined}
          options={options}
          onChange={handleOnChange}
        />
      );
    } else {
      return (
        <TextInput
          text="Discount title"
          value={form.title}
          name="title"
          onChange={onChange}
        />
      );
    }
  }

  return (
    <>
      {!form.id && (
        <SelectableMenu
          options={[
            {
              label: "Product",
              value: "product",
            },
            {
              label: "Category",
              value: "category",
            },
            {
              label: "Cart",
              value: "cart",
            },
          ]}
          className="order-discount-options"
          value={form.discount_type}
          setValue={(value) => {
            setForm((prev) => ({
              ...prev,
              discount_type: value,
              brand_id: null,
              product_id: null,
            }));
            // onChange({ target: { name: "discount_type", value } })
          }}
        />
      )}
      <div
        className="d-flex justify-content-between align-items-center mb-4"
        style={{
          gap: 5,
        }}
      >
        <div
          style={{
            width: "60%",
          }}
        >
          {renderFormInput()}
        </div>
        <div
          style={{
            width: "30%",
          }}
        >
          <TextInput
            type="number"
            text="Discount amount"
            value={form.amount}
            name="amount"
            suffix={
              <div>
                {["%", "€"].map((tag) => (
                  <span
                    key={tag}
                    className="text-sm cursor-pointer"
                    style={{
                      color: tag == form.amount_type ? "#212529" : "#BFBFBF",
                      borderBottom:
                        tag == form.amount_type ? "1px solid #FFA800" : null,
                    }}
                    onClick={() =>
                      onChange({
                        target: {
                          name: "amount_type",
                          value: tag,
                        },
                      })
                    }
                  >
                    {tag}
                  </span>
                ))}
              </div>
            }
            onChange={onChange}
          />
        </div>
        <div>
          <Label>-</Label>
          {!!form.id ? (
            <div className="d-flex flex-row">
              <div
                className="mr-1 cursor-pointer"
                onClick={() => {
                  dispatch(updateOrderCartRules(form));
                  onClose();
                }}
              >
                <FaCheck color="green" />
              </div>
              <div onClick={onClose}>
                <IconTimes color='red' />
              </div>
            </div>
          ) : (
            <button
              className="btn btn-sm btn-primary"
              style={{
                height: "100%",
              }}
              onClick={() => {
                dispatch(createOrderCartRules(initialValues.order_id, form));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <path
                  d="M7.94995 0.924927C5.86921 0.950174 3.88081 1.78796 2.4094 3.25938C0.937989 4.73079 0.100198 6.71919 0.0749512 8.79993C0.100198 10.8807 0.937989 12.8691 2.4094 14.3405C3.88081 15.8119 5.86921 16.6497 7.94995 16.6749C10.0307 16.6497 12.0191 15.8119 13.4905 14.3405C14.9619 12.8691 15.7997 10.8807 15.825 8.79993C15.7997 6.71919 14.9619 4.73079 13.4905 3.25938C12.0191 1.78796 10.0307 0.950174 7.94995 0.924927ZM12.45 9.36243H8.51245V13.2999H7.38745V9.36243H3.44995V8.23743H7.38745V4.29993H8.51245V8.23743H12.45V9.36243Z"
                  fill="white"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </>
  );
};
